var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define('studio/suit-panel',["require", "exports", "../tracks/track", "../tracks/track-enabled", "../tracks/track-store", "../util/log", "../util/pubsub", "../views/autocomplete"], function (require, exports, track_1, trackEnabled, trackStore, log, pubsub_1, autocomplete_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SuitPanel = void 0;
    var excludeSuits = ["Normal clothes"];
    var SuitPanel = /** @class */ (function () {
        function SuitPanel(userId) {
            var _this = this;
            this.clicks = new pubsub_1.PubSub();
            this.tracks = trackStore.getUserTracks(userId);
            this.suits = this.getSuits(this.tracks);
            this.suits.then(function (suits) {
                var input = document.getElementById("studio-suit-input");
                var filtered = suits.filter(function (s) { return excludeSuits.indexOf(s) < 0; });
                var ac = new autocomplete_1.Autocomplete({
                    input: input,
                    items: filtered,
                    minLength: 0,
                    display: function (suit) { return suit; },
                    filter: function (suit) { return suit; },
                    value: function (suit) { return suit; }
                });
                ac.updates.subscribe(function (suit) {
                    _this.clickSuit(suit);
                    input.value = "";
                });
            });
            // TODO: Set on select
        }
        SuitPanel.prototype.getSuits = function (futureTracks) {
            return futureTracks.then(function (tracks) {
                var bySuit = {};
                for (var _i = 0, tracks_1 = tracks; _i < tracks_1.length; _i++) {
                    var track = tracks_1[_i];
                    if (track.suit && (0, track_1.jumpType)(track) === "BASE") {
                        if (bySuit[track.suit]) {
                            bySuit[track.suit].push(track);
                        }
                        else {
                            bySuit[track.suit] = [track];
                        }
                    }
                }
                // Sort by count of suit
                return Object.keys(bySuit)
                    .sort(function (s1, s2) { return bySuit[s2].length - bySuit[s1].length; });
            });
        };
        SuitPanel.prototype.clickSuit = function (suitName) {
            return __awaiter(this, void 0, void 0, function () {
                var all, _i, all_1, trackMetadata, enabled;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            log.info("studio suit " + suitName);
                            return [4 /*yield*/, this.tracks];
                        case 1:
                            all = _a.sent();
                            for (_i = 0, all_1 = all; _i < all_1.length; _i++) {
                                trackMetadata = all_1[_i];
                                enabled = trackEnabled.isEnabled(trackMetadata.track_id);
                                if (trackMetadata.suit === suitName && (0, track_1.jumpType)(trackMetadata) === "BASE") {
                                    if (!enabled) {
                                        trackEnabled.addTrack(trackMetadata.track_id);
                                        this.clicks.post(suitName);
                                    }
                                }
                                else if (enabled) {
                                    trackEnabled.remove(trackMetadata.track_id);
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        return SuitPanel;
    }());
    exports.SuitPanel = SuitPanel;
});
//# sourceMappingURL=/assets/javascripts/studio/suit-panel.js.map;
